import { useState } from "react";
import { Link } from "react-router-dom";
import { HeartPulse, MailCheck } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, apiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto flex min-h-screen max-w-md flex-col justify-center px-6">
        <Link to="/" className="mb-8 flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#0284C7] text-white"><HeartPulse className="h-5 w-5" strokeWidth={2.6} /></div>
          <span className="text-lg font-extrabold tracking-tight text-slate-900">SaludCitaRD</span>
        </Link>
        <div className="rounded-2xl border border-[#E2E8F0] bg-white p-8">
          {sent ? (
            <div className="text-center">
              <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-emerald-50 text-emerald-500"><MailCheck className="h-6 w-6" /></div>
              <h1 className="text-2xl font-extrabold tracking-tight text-slate-900">Revisa tu correo</h1>
              <p className="mt-2 text-sm font-semibold text-slate-500" data-testid="forgot-sent-msg">
                Si el correo está registrado, te enviamos un enlace para restablecer tu contraseña. El enlace expira en 1 hora.
              </p>
              <Link to="/login"><Button className="mt-6 w-full rounded-full bg-[#0284C7] font-bold hover:bg-[#0369a1]" data-testid="back-to-login-btn">Volver a iniciar sesión</Button></Link>
            </div>
          ) : (
            <>
              <h1 className="text-2xl font-extrabold tracking-tight text-slate-900">Recuperar contraseña</h1>
              <p className="mt-1 text-sm font-semibold text-slate-500">Ingresa tu correo y te enviaremos un enlace para restablecerla.</p>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <div>
                  <Label className="text-xs font-bold uppercase tracking-wider text-slate-500">Correo</Label>
                  <Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 rounded-xl border-[#E2E8F0]" data-testid="forgot-email-input" />
                </div>
                <Button type="submit" disabled={busy} className="w-full rounded-full bg-[#0284C7] font-bold hover:bg-[#0369a1]" data-testid="forgot-submit-btn">
                  {busy ? "Enviando…" : "Enviar enlace"}
                </Button>
              </form>
              <p className="mt-6 text-center text-sm font-semibold text-slate-500">
                <Link to="/login" className="font-bold text-[#0284C7]">Volver a iniciar sesión</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
